import React from 'react';
import { Link } from 'react-router-dom';
import type { PublicFiche } from '../types';
import { PrincipeSection } from './sections/PrincipeSection';

interface FicheCardPrincipeProps {
  fiche: PublicFiche;
}

/**
 * Carte arrêt de principe — remplace PrincipeCard inline dans PublicPrincipes.
 *
 * Layout propre à la carte principe (border amber, padding p-5, pas de footer articles).
 * Ne passe PAS par FicheCardBase car la structure visuelle est différente.
 */
export const FicheCardPrincipe = ({ fiche }: FicheCardPrincipeProps) => (
  <Link
    to={`/jurisprudence/${fiche.slug}`}
    className="block rounded-xl border border-amber-200 dark:border-amber-800 border-l-4 border-l-amber-400 bg-card hover:bg-amber-50/30 dark:hover:bg-amber-900/10 hover:border-amber-300 transition-all p-5 group"
  >
    <PrincipeSection fiche={fiche} />
  </Link>
);